export const getImageFormData = (image: File | null) => {
  const form = new FormData();
  if (image) form.append("file", image);

  return form;
};

export const getFormData = <T>(values: T) => {
  const form = new FormData();

  Object.keys(values as any).forEach((key) => {
    form.append(key, (values as any)[key]);
  });

  return form;
};
